import React from "react";
import { useSelector } from "react-redux";
import functions from "../utils/functions";
import { Navigate, useSearchParams } from "react-router-dom";
import { getSafeInternalRedirect } from "../utils/postLoginRedirect";

export function PublicRoute({ Component, props }) {
  const { user } = useSelector((state) => state.user);
  const [searchParams] = useSearchParams();

  if (user) {
    const safeRedirect = getSafeInternalRedirect(
      searchParams.get("redirect"),
    );
    const target =
      safeRedirect ?? functions.getInitialDashboardRoute(user?.role);
    return <Navigate to={target} replace={true} />;
  } else {
    return <Component {...props} />;
  }
}
